import { GAME_PROMOTION_ALL_COUNTRIES } from 'src/constants';
import { compareByAlphabet } from 'src/helpers/sorting';
import type {
  GamePromotionCountriesResponse,
  GamePromotionCountriesTransformed,
  GamePromotionSummaryResponse,
  GamePromotionSummaryTransformed,
} from 'src/types/game-promotion';

export const transformGetGamePromotionCountriesResponse: (
  res: GamePromotionCountriesResponse,
) => GamePromotionCountriesTransformed = (res) =>
  res.values
    .map(({ country: { countryFullName, countryIsoCode }, promotionsRecordsCount }) => ({
      countryFullName,
      countryIsoCode,
      totalAmount: promotionsRecordsCount,
    }))
    .sort((a, b) =>
      a.countryIsoCode === GAME_PROMOTION_ALL_COUNTRIES
        ? 1
        : b.countryIsoCode === GAME_PROMOTION_ALL_COUNTRIES
          ? -1
          : compareByAlphabet(a.countryFullName, b.countryFullName),
    );

export const transformGetGamePromotionSummaryResponse: (
  res: GamePromotionSummaryResponse,
) => GamePromotionSummaryTransformed = (res) => res.values;
